module.exports = __webpack_public_path__ + "img/echarts_rightbg.50ce87f4.png";